import { assertValidVersion } from "@tsparticles/engine";
import { ColorUpdater } from "./ColorUpdater.js";
export async function loadColorUpdater(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addParticleUpdater("color", container => {
        return Promise.resolve(new ColorUpdater(container, engine));
    }, refresh);
}
